export default __webpack_public_path__ + "972df7bfa66a885c09e59deb04747361.png";